import { render, staticRenderFns } from "./breadcrumb-item-picker.vue?vue&type=template&id=dc3d69dc&"
import script from "./breadcrumb-item-picker.vue?vue&type=script&lang=ts&"
export * from "./breadcrumb-item-picker.vue?vue&type=script&lang=ts&"
import style0 from "./breadcrumb-item-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports